import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon-team.png'


const _withScopeId = n => (_pushScopeId("data-v-45bea734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-team-player-wrapper" }
const _hoisted_2 = { class: "layout-inner -wide -top-and-bottom" }
const _hoisted_3 = {
  key: 0,
  class: "season-team-player-content"
}
const _hoisted_4 = { class: "return" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 戻る ")
const _hoisted_6 = { class: "team-player-header" }
const _hoisted_7 = { class: "category" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "チーム情報を見る", -1))
const _hoisted_11 = { class: "team-player-body" }
const _hoisted_12 = { class: "first-block" }
const _hoisted_13 = { class: "player-select-block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "選手を選択", -1))
const _hoisted_15 = {
  class: "global-search-input",
  onsubmit: "return false;",
  action: "/"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-search icon" }, null, -1))
const _hoisted_17 = { class: "player-list-block" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "在籍選手", -1))
const _hoisted_19 = {
  key: 0,
  class: "player-list"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "global-empty-text -small"
}
const _hoisted_22 = {
  key: 1,
  class: "global-empty-text -small"
}
const _hoisted_23 = { class: "player-entry-block" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "選手をscorebeeに登録して選択", -1))
const _hoisted_25 = { class: "save" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-check-icon" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "scorebeeに登録", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "second-block" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-arrow-right arrowIcon" }, null, -1))
const _hoisted_32 = { class: "uniform-number-block" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "背番号登録", -1))
const _hoisted_34 = { class: "name" }
const _hoisted_35 = {
  key: 1,
  class: "empty"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode("左の選択欄から")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode("登録する選手を選択する")
const _hoisted_39 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = { class: "third-block" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-arrow-right arrowIcon" }, null, -1))
const _hoisted_42 = { class: "entry-player-block" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry-player-heading" }, "登録選手", -1))
const _hoisted_44 = {
  key: 0,
  class: "entry-player-list"
}
const _hoisted_45 = ["onUpdate:modelValue", "onChange"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 1,
  class: "global-empty-text -small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.entry.data != undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  class: "global-return-link",
                  to: {
              name: 'seasonEntryDetail',
              params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id } }
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", {
                    class: "categoryIcon",
                    style: _normalizeStyle({ 'background-color': _ctx.entry.data.category_color })
                  }, null, 4),
                  _createElementVNode("span", {
                    class: "categoryText",
                    style: _normalizeStyle({ color: _ctx.entry.data.category_color })
                  }, _toDisplayString(_ctx.entry.data.category_name), 5)
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.entry.data.team_name) + " " + _toDisplayString(_ctx.entry.data.division), 1),
                _createVNode(_component_router_link, {
                  to: { name: 'teamDetail', params: { team_id: parseInt(_ctx.entry.data.team_id) } },
                  class: "team-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("form", _hoisted_15, [
                      _hoisted_16,
                      _withDirectives(_createElementVNode("input", {
                        type: "search",
                        class: "input",
                        placeholder: "追加する選手を検索",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.keyword) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.searchForm.keyword]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      (_ctx.rosters.within.length > 0)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rosters.within, (player) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: player.id,
                                class: "item"
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "button",
                                  onClick: ($event: any) => (_ctx.selectEntryPlayer(player))
                                }, _toDisplayString(player.name), 9, _hoisted_20)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.isSearching)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_21, "該当する選手がいません"))
                              : (_openBlock(), _createElementBlock("p", _hoisted_22, "登録されている選手がいません"))
                          ], 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "global-input",
                      placeholder: "登録する選手名を入力",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.playerFormAdd.name) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.playerFormAdd.name,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("button", {
                        class: "global-button",
                        disabled: !_ctx.playerFormAdd.isCompleted,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addPlayerToMasio && _ctx.addPlayerToMasio(...args)))
                      }, _hoisted_29, 8, _hoisted_26)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    (_ctx.playerFormRegister.name)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "global-input",
                            placeholder: "背番号",
                            ref: "numberInputElement",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.playerFormRegister.number) = $event)),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeUniformNumber($event, 'add')))
                          }, null, 544), [
                            [_vModelText, _ctx.playerFormRegister.number]
                          ]),
                          _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.playerFormRegister.name), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock("p", _hoisted_35, _hoisted_39))
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    (_ctx.rosters.list.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_44, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rosters.list, (player) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: player.id,
                              class: "item"
                            }, [
                              _createVNode(_component_router_link, {
                                to: { name: 'playerDetail', params: { player_id: player.player_id } },
                                class: "link"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "number",
                                    "onUpdate:modelValue": ($event: any) => ((player.number) = $event),
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                                    onChange: ($event: any) => (_ctx.onChangeUniformNumber($event, 'update', player))
                                  }, null, 40, _hoisted_45), [
                                    [_vModelText, player.number]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(player.player_name) + " ", 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "global-delete-button",
                                    onClick: _withModifiers(($event: any) => (_ctx.openPlayerDialogDeleteFromSeason(player)), ["prevent"])
                                  }, _hoisted_48, 8, _hoisted_46)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_49, "登録されている選手がいません"))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.playerDialogMoveConfirm.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.playerDialogMoveConfirm,
          onCloseDialog: _ctx.closePlayerDialogMoveConfirm,
          onOnConfirm: _ctx.movePlayer
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.playerDialogDeleteFromSeason.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 1,
          dialog: _ctx.playerDialogDeleteFromSeason,
          onCloseDialog: _ctx.closePlayerDialogDeleteFromSeason,
          onOnConfirm: _ctx.deletePlayerFromSeason
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}